// extracted by mini-css-extract-plugin
export var label = "_e6-5";
export var slideContainer = "_e6-0";
export var slider = "_e6-1";
export var sliderLg = "_e6-4";
export var sliderMd = "_e6-3";
export var sliderSm = "_e6-2";